import React, { useContext, useState } from 'react';
import { DropResult } from 'react-beautiful-dnd';

import AccountPickerContext from 'contexts/AccountPickerContext';
import STORE from 'store';
import QuickFilters from '../../CustomerLaneCommitsBoard/Settings/QuickFilters/QuickFilters';
import { FilterBarSettings, orderQuickFilters } from '../filterBarSettings';
import NewReportQuickFilterForm from './NewReportQuickFilterForm';

// A report's or dashboard's quick filters: added, edited, reordered and
// deleted
const ReportQuickFiltersSettings = ({
  settings,
  close,
}: {
  settings: FilterBarSettings;
  close: () => void;
}) => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const { quickFilters, quickFilterOrder, save } = settings;
  const [isCreatingNewFilter, setIsCreatingNewFilter] =
    useState<boolean>(false);
  const [editingFilter, setEditingFilter] = useState<
    LegacySavedFilter | undefined
  >(undefined);

  const orderedFilters = orderQuickFilters({ quickFilters, quickFilterOrder });

  const onDragEnd = (result: DropResult) => {
    const { draggableId, destination } = result;
    if (!destination) {
      return;
    }

    const itemsWithoutDropped = orderedFilters.filter(
      (f) => f.id !== draggableId,
    );

    const newOrder = [
      ...itemsWithoutDropped.slice(0, destination.index).map((f) => f.id),
      draggableId,
      ...itemsWithoutDropped
        .slice(destination.index, itemsWithoutDropped.length)
        .map((f) => f.id),
    ];

    save({ quickFilterOrder: newOrder });
  };

  const deleteFilter = (f: LegacySavedFilter) => {
    STORE.filterDefinitions
      .getLegacySavedFiltersRef({ accountId: selectedAccountId })
      .doc(f.id)
      .delete()
      .then(() =>
        save({
          quickFilterOrder: quickFilterOrder.filter((fid) => fid !== f.id),
        }),
      );
  };

  const closeForm = () => {
    setIsCreatingNewFilter(false);
    setEditingFilter(undefined);
  };

  if (isCreatingNewFilter || editingFilter) {
    return (
      <NewReportQuickFilterForm
        settings={settings}
        quickFilter={editingFilter}
        close={closeForm}
      />
    );
  }

  return (
    <QuickFilters
      isCreatingNewFilter={isCreatingNewFilter}
      setIsCreatingNewFilter={setIsCreatingNewFilter}
      orderedFilters={orderedFilters}
      onDragEnd={onDragEnd}
      deleteFilter={deleteFilter}
      editFilter={setEditingFilter}
      close={close}
    />
  );
};

export default ReportQuickFiltersSettings;
